import { IconActionDownload, IconAttachmentFile } from '../icons/svgs';
import PdfViewer from './DocumentPreview/Pdf';

function DocumentPreview({ data, index, inEditor, structures }) {
    const canDownloadDocument = () => {
        let canDownload = false;
        if (data?.attachment?.fileId) {
            if (data?.attachment?.type === 'application/pdf') {
                if (data?.downloadable === true || data?.downloadable === 'true') {
                    canDownload = true;
                }
            } else {
                canDownload = true;
            }
        }
        return canDownload;
    }

    const classAttachmentAction = () => {
        if (!canDownloadDocument() && data?.attachment?.type === 'application/pdf') {
            return ' d-none';
        }
        return '';
    }
    return (
        <div className="tbcourse-template tbcourse-template-document" key={index}>
            <div>
                <div className="tbcourse-template-text-title">{data?.title ? data.title : structures.title?.placeholder}</div>
                <div className={`tbcourse-template-attachment` + (data?.attachment?.fileId ? '' : ' file-empty') + (data?.attachment?.type === 'application/pdf' ? ' pdf-viewer-container' : '')}>
                    <div className="tbcourse-template-attachment-file-type">
                        <IconAttachmentFile />
                    </div>
                    { data?.attachment?.type === 'application/pdf' && (
                        <PdfViewer data={data}/>
                    )}
                    <div className={`tbcourse-template-attachment-action`+ classAttachmentAction()}>
                        {/* {data?.attachment?.fileId ? ( */}
                        {canDownloadDocument() ? (
                            <a href={data.attachment.fullUrl} role="button" className="btn" target='_blank' download={true} rel="noreferrer">
                                Download Document <IconActionDownload />
                            </a>
                        ) : (
                            <button type="button" className="btn">
                                Download Document <IconActionDownload />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DocumentPreview;
